var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"mt-5 text-center"},[_c('h2',[_vm._v("Bienvenido, "+_vm._s(_vm.user?.name))]),_c('b-button',{attrs:{"variant":"danger"},on:{"click":_vm.logout}},[_vm._v("Cerrar sesión")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }